import React, { useState, useEffect, useRef } from 'react';
import Indicator from './Components/Indicator';
import { setCSSProperty } from '../../Utils/css.utils';
import { useElementSize } from '../../Hooks/useElementSize.js';
import Images from './Components/Images';

const ImageSlider = ({ images }) => {
  if (!images || images.length < 1) return null;

  const barWidth = 100 / images.length;
  const sliderContainerClass = '.image-slider-container';
  const sliderContainer = document.querySelector(sliderContainerClass);
  const imageSlider = document.querySelector('.image-slider');

  const [currentSlide, setCurrentSlide] = useState(1);

  const setCSSPropertySlider = (prop, val) =>
    setCSSProperty(sliderContainerClass, prop, val);

  const sliderRef = useRef();
  let sliderWidth = useElementSize(sliderRef);

  useEffect(() => setCSSPropertySlider('bar-width', `${barWidth}%`));

  useEffect(() => {
    if (!(sliderContainer || imageSlider)) return;

    const slide = currentSlide - 1;
    setCSSPropertySlider('bar-left', `${slide * barWidth}%`);

    imageSlider.scrollTo({
      left: slide * sliderWidth,
      behavior: 'smooth',
    });
  }, [currentSlide]);

  const handleSlide = (slide) => setCurrentSlide(currentSlide + slide);

  return (
    <div className="image-slider-container">
      <Images
        ref={sliderRef}
        images={images}
        currentSlide={currentSlide}
        handleSlide={handleSlide}
      />
      <Indicator
        currentSlide={currentSlide}
        imagesLength={images.length}
        handleSlide={handleSlide}
      />
    </div>
  );
};

export default ImageSlider;
